import React from 'react';
import { Card, CardContent } from './Card';

interface StatBoxProps {
  title: string;
  value: string | number;
  icon: React.ComponentType<{ className?: string }>;
  iconBgColor?: string;
  iconColor?: string;
  className?: string;
  gradientFrom?: string;
  variant?: 'default' | 'primary' | 'success' | 'destructive' | 'warning';
}

const StatBox: React.FC<StatBoxProps> = ({
  title,
  value,
  icon: Icon,
  iconBgColor = 'bg-muted',
  iconColor = 'text-muted-foreground',
  className = '',
  gradientFrom,
  variant = 'default',
}) => {
  // Theme-aware gradient colors that work in both light and dark modes
  const getGradientFromVariant = () => {
    if (gradientFrom) return gradientFrom;
    
    switch (variant) {
      case 'primary':
        return 'from-primary/10';
      case 'success':
        return 'from-success/10';
      case 'destructive':
        return 'from-destructive/10';
      case 'warning':
        return 'from-warning/10';
      default:
        return 'from-muted/10';
    }
  };
  return (
    <Card className={`group relative overflow-hidden transition-all duration-300 hover:shadow-xl ${className}`}>
      <CardContent className="p-6">
        <div className={`absolute inset-0 bg-gradient-to-br ${getGradientFromVariant()} to-card opacity-0 transition-opacity duration-300 group-hover:opacity-100`}></div>
        <div className="relative">
          <div className="flex items-center justify-between">
            <div className={`rounded-xl p-3 ${iconBgColor} shadow-sm`}>
              <Icon className={`h-6 w-6 ${iconColor}`} />
            </div>
            <div className="text-right">
              <p className="text-3xl font-bold text-foreground">
                {typeof value === 'number' ? value.toLocaleString() : value}
              </p>
            </div>
          </div>
          <div className="mt-4">
            <p className="text-sm font-medium text-muted-foreground">{title}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default StatBox;